(function () {
  if (window.themeSettings?.priceOnAskEnabled === false) return;

  const ENQUIRE_FORM_ID = 'MTUxNjgx';
  const ENQUIRE_LABEL = window.variantStrings?.enquire || 'Enquire';
  const ATC_SELECTOR =
    '[data-pf-type="ProductATC2"], button[name="add"]:not(.product-form__enquire), .quick-add__submit[type="submit"]:not(.product-form__enquire), .product-form__submit[type="submit"]:not(.product-form__enquire)';

  function createEnquireButton(templateButton) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `${templateButton.className} product-form__enquire globo-formbuilder-open`.trim();
    button.dataset.id = ENQUIRE_FORM_ID;
    button.innerHTML = `<i class="porto-icon-bag-2"></i><span>${ENQUIRE_LABEL}</span>`;
    return button;
  }

  function replaceWithEnquire(button) {
    if (!button || button.classList.contains('product-form__enquire')) return;

    const enquireButton = createEnquireButton(button);
    if (button.id) enquireButton.id = button.id;

    button.replaceWith(enquireButton);
  }

  function getPageflyProductEnquire(productId) {
    const product = window.__pageflyProducts?.[productId];
    return product?.showEnquire === true;
  }

  function getProductId(button) {
    if (button.dataset.productId) return button.dataset.productId;
    const container = button.closest('[data-product-id]');
    return container?.dataset.productId;
  }

  function isProductPageBuyButton(button) {
    return Boolean(button.closest('product-info .product-form'));
  }

  function shouldEnquire(button) {
    if (isProductPageBuyButton(button)) return false;

    const container = button.closest('[data-show-enquire="true"], [data-pf-type="ProductBox"]');
    if (!container) return false;
    if (container.dataset.showEnquire === 'true') return true;

    const productId = getProductId(button);
    if (productId && getPageflyProductEnquire(productId)) return true;

    return false;
  }

  function hideQuantityForEnquire(button) {
    const card = button.closest('.card-wrapper, [data-pf-type="ProductBox"], .product-form, product-form');
    if (!card) return;
    card.querySelectorAll('.product-form__quantity, quantity-input, .quantity-popover').forEach((el) => {
      el.classList.add('hidden');
    });
  }

  function processButton(button) {
    if (!shouldEnquire(button)) return;
    replaceWithEnquire(button);
    hideQuantityForEnquire(button);
  }

  function getPageflyProductHidePrice(productId) {
    const product = window.__pageflyProducts?.[productId];
    return product?.hidePrice === true;
  }

  function shouldHidePrice(container) {
    if (container.dataset.hidePrice === 'true') return true;

    const productId = container.dataset.productId;
    if (productId && getPageflyProductHidePrice(productId)) return true;

    return false;
  }

  function hidePrices(container) {
    if (!shouldHidePrice(container)) return;

    container
      .querySelectorAll(
        '.price, [data-pf-type="ProductPrice2"], [data-pf-type="ProductPrice2Item"], [data-product-price="true"]'
      )
      .forEach((el) => {
        el.classList.remove('hidden');
        el.classList.add('product-price--hidden');
      });
  }

  function processContainer(container) {
    hidePrices(container);
  }

  function processPage() {
    document.querySelectorAll(ATC_SELECTOR).forEach(processButton);
    document
      .querySelectorAll('[data-hide-price="true"], [data-product-id][data-pf-type="ProductBox"]')
      .forEach(processContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processPage);
  } else {
    processPage();
  }

  document.addEventListener('shopify:section:load', processPage);
})();
